/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M900.604 211.748H124.003c-42.72 0-77.673-34.953-77.673-77.672s34.953-77.673 77.673-77.673h776.48c42.72 0 77.672 34.953 77.672 77.673.122 42.72-34.831 77.672-77.55 77.672zm0 380.23h-771.99c-42.72 0-77.672-34.952-77.672-77.672s34.953-77.672 77.672-77.672h771.99c42.72 0 77.673 34.952 77.673 77.672s-34.953 77.672-77.673 77.672zm0 387.148H124.003c-42.72 0-77.673-34.952-77.673-77.672s34.953-77.673 77.673-77.673h776.48c42.72 0 77.672 34.953 77.672 77.673.122 42.72-34.831 77.672-77.55 77.672z" _fill="#666"/>'
  }
})
